var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"163","height":"163","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M83.86,127A45.56,45.56,0,0,1,39.14,90l-4.79,4.77a1.53,1.53,0,0,1-1.06.41,1.5,1.5,0,0,1-1.06-.44L26,88.5a1.51,1.51,0,0,1,0-2.12L42.45,70.15A1.49,1.49,0,0,1,44.37,70l18.5,13.07a1.49,1.49,0,0,1,.36,2.09l-5,7.16a1.51,1.51,0,0,1-2.09.36L51,89.06a33.76,33.76,0,1,0,1.94-20.94,1.53,1.53,0,0,1-2,.78l-8-3.49a1.5,1.5,0,0,1-.79-2v0A45.51,45.51,0,1,1,83.86,127ZM40.18,85.33a1.37,1.37,0,0,1,.49.09,1.49,1.49,0,0,1,1,1.23,42.5,42.5,0,1,0,3.81-23.42l5.3,2.29a36.76,36.76,0,1,1-3.39,20.36,1.49,1.49,0,0,1,2.35-1.4l6.85,4.83,3.33-4.7L43.67,73.15,29.24,87.46l4.06,4.09,5.82-5.78A1.5,1.5,0,0,1,40.18,85.33Z","key":1}),React.createElement("path",{"d":"M70.8,97.06a1.49,1.49,0,0,1-1.5-1.48,1.42,1.42,0,0,1,.39-1L82.85,80V59.38a1.5,1.5,0,1,1,3,0v21.2a1.5,1.5,0,0,1-.39,1l-13.54,15A1.52,1.52,0,0,1,70.8,97.06Z","key":2}),React.createElement("circle",{"cx":"84.35","cy":"109.24","r":"2.11","key":3}),React.createElement("circle",{"cx":"99.69","cy":"103.82","r":"2.11","key":4}),React.createElement("circle",{"cx":"108.77","cy":"90.83","r":"2.11","key":5}),React.createElement("circle",{"cx":"110.2","cy":"74.36","r":"2.11","key":6})]);
}

Icon.displayName = "Icon";

Icon.defaultProps = {"viewBox":"0 0 163 163"};

module.exports = Icon;

Icon.default = Icon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js?name=Icon!./src/components/icons/homeowners-icon-quick.svg
// module id = 294
// module chunks = 0